export const openRoutes = {
  root: '/',
};

export const protectedRoutes = {
  activeJobs: '/active-jobs',
  search: '/search',
  searchResults: '/search-results',
  tracker: '/tracker',
};
